import { Code, ConnectError } from '@bufbuild/connect';

export const isConnectNetworkError = (connectError: ConnectError) => {
  return (
    connectError.code === Code.Unknown &&
    connectError.message.includes('network')
  );
};
